.utilityPage {
    // There's a specific scenario on the Awards Page where CenteredHero wants
    // to be sized in a way to make sure the AnimatedCarousel beneath it shows.
    & :global(.centeredHeroDesktopStatic) {
        &:has(+ * + :global(.animatedCarouselStatic)) > * {
            min-height: 540px !important;
        }
    }
}
